var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6854_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8149 9.71858L5.11719 8.18408V19.5225C5.11719 20.0403 5.53706 20.4601 6.055 20.4601H21.0631C21.581 20.4601 22.0009 20.0403 22.0009 19.5225V15.3451L13.8149 9.71858Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8149 0H6.055C5.53706 0 5.11719 0.419766 5.11719 0.937577V5.115L13.8149 10.23L18.4195 11.7645L22.0009 10.23V5.115L13.8149 0Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11719 5.11523H13.8149V10.2302H5.11719V5.11523Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.3422 4.0918H5.11719V16.8793H11.3422C11.8594 16.8776 12.2783 16.4588 12.28 15.9417V5.02937C12.2783 4.51226 11.8594 4.09348 11.3422 4.0918Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.8305 4.60352H5.11719V17.391H10.8305C11.3478 17.3893 11.7667 16.9705 11.7684 16.4534V5.54109C11.7667 5.02398 11.3478 4.6052 10.8305 4.60352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.8305 4.60352H5.11719V16.368H10.8305C11.3478 16.3663 11.7667 15.9475 11.7684 15.4304V5.54109C11.7667 5.02398 11.3478 4.6052 10.8305 4.60352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.3189 4.60352H5.11719V16.368H10.3189C10.8361 16.3663 11.255 15.9475 11.2567 15.4304V5.54109C11.255 5.02398 10.8361 4.6052 10.3189 4.60352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.937812 4.60352H10.318C10.8359 4.60352 11.2558 5.02328 11.2558 5.54109V14.9189C11.2558 15.4367 10.8359 15.8565 10.318 15.8565H0.937812C0.419871 15.8565 0 15.4368 0 14.9189V5.54109C0 5.02328 0.419871 4.60352 0.937812 4.60352Z",
    fill: "url(#paint0_linear_6854_64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90625 13.2777L4.87909 10.2215L3.07151 7.18213H4.52555L5.51197 9.12583C5.60304 9.31048 5.66546 9.44756 5.69923 9.53809H5.71202C5.77682 9.39078 5.84504 9.24773 5.91667 9.10894L6.97113 7.18316H8.30597L6.45234 10.2046L8.35305 13.2777H6.93277L5.79337 11.1442C5.7397 11.0534 5.69416 10.9581 5.65728 10.8593H5.6404C5.60702 10.9561 5.56274 11.0488 5.50839 11.1355L4.33523 13.2777H2.90625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0607 0H13.8125V5.115H21.9985V0.937577C21.9985 0.419766 21.5787 0 21.0607 0Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8125 10.23H21.9985V15.345H13.8125V10.23Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6854_64",
    x1: 1.95536,
    y1: 3.87091,
    x2: 9.2977,
    y2: 16.5907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6854_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20.46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excelIcon.4c1b6f2a71c483d64d61a7de89e95c68.svg";
export { ForwardRef as ReactComponent };